<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
               <li class="active">{{assetTypeMap[query.assetType]}}流水</li>
            </ol>
        </div> 
        <div class="content-query content-border">
            <el-form :inline="true" :model="query">
                <el-form-item label="账号：">
                    <el-input clearable type="text" v-model="query.nickname"></el-input>
                </el-form-item>
                <el-form-item label="操作类型:">
                    <el-select clearable  v-model="query.tradeType">
                        <el-option  v-for="item in assetTradeType" :key="item.name" :label="item.label" :value="item.name">
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="title">
            <span>{{assetTypeMap[query.assetType]}}详情列表</span>
        </div>
        <div class="content-data" v-if="assetDetail && 0 < assetDetail.length">
            <el-table :data="assetDetail" highlight-current-row border>
                <el-table-column  type="index" align="center"/>
              <el-table-column label="用户信息" align="center">
                <template slot-scope="scope">
                  <user-info :icon-path="scope.row.iconPath" :nickname="scope.row.nickname"/>
                </template>
              </el-table-column>
                <el-table-column label="(收入/支出)" prop="tradeAmount" align="center"/>
                <el-table-column label="剩余" prop="remainder" align="center"/>
                <el-table-column label="交易时间" prop="createTime" align="center"/>
                <el-table-column label="交易类型" align="center">
                    <template slot-scope="scope">
                        <span>{{assetTradeTypeMap[scope.row.tradeType]}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="assetDetailCount/pageAssetDetailByManager" v-bind:query="query" v-bind:contentType="contentType" ref="pager" v-bind:init="true"></vue-pager> 
    </div>
</template>
<script>
export default {
    data() {
        return {
            assetDetail: [],
            query: {},
            contentType: 'application/json',
            assetDetailTypeItem:[],
            total:{},
            assetTypeMap:{},
            assetTradeTypeMap:{},
        }
    },
    created() {
        var _this = this;
        _this.$set(_this.query, 'assetType', _this.$route.query.assetType);
        var assetType = _this.$common.enum_config('EAssetType');
        assetType.forEach((item)=>{
            _this.assetTypeMap[item.name] = item.label;
        });
        var assetTradeType = _this.$common.enum_config('EAssetTradeType');
        assetTradeType.forEach((item)=>{
            _this.assetTradeTypeMap[item.name] = item.label;
        });
        assetTradeType.splice(0, 0, { name: null, label: '全部' });
        _this.assetTradeType=assetTradeType;
        _this.countBySelfGroupByTradeTypeByManager();
    },
    methods: {
        countBySelfGroupByTradeTypeByManager() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'assetDetailCount/countBySelfGroupByTradeTypeByManager',
                data: _this.query,
                success: function(response) {
                    _this.total=response.item;
                    
                }
            });
        },
        fillData(_response) {
            var _this = this;
            _this.assetDetail = _response.items;
        },
        submitQuery(_num) {
            var _this = this;
   
            _this.assetDetail = [];
            _this.$refs.pager.gotoPage(_num);
        },
    },
    watch:{
      '$route' (to, from) {
        var _this = this;
        if (to.name === from.name) {
          _this.query = {
            assetType: _this.$route.query.assetType
          };
          _this.$nextTick(function() {
            _this.$refs.pager.gotoPage();
          });
        }
      }
    }
}
</script>
<style scoped>
.yuan{
    font-size:18px;
    padding: 5px 0;
    font-weight:600;
}
.colorgreen{
    color:#22ca18;
}
.colorrad{
    color:#fb0101;
}
.tong{
    width: 40%
}
.table td{
    text-align: center;
}
</style>
